export function renderSingleHookComponentTemplate({
  singular,
  actionImportPath,
  schemaName
}: {
  singular: string
  actionImportPath: string
  schemaName: string
}): string {
  return `import {
  get${singular},
  type ${singular}
} from '@admin/actions/${actionImportPath}'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'

interface Use${singular}Options {
  initialData?: ${singular} | null
}

export function use${singular}(options: Use${singular}Options = {}): UseQueryResult<${singular} | null, Error> {
  return useQuery({
    queryKey: ['${schemaName}'],
    queryFn: () => get${singular}(),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    ...(options.initialData !== undefined ? { initialData: options.initialData } : {}),
  })
}
`
}
